import RocketIcon from '@/public/images/dashboard/rocket.svg';
import DashboardEmptyStateCard from '@/components/Dashboard/DashboardEmptyStateCard';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

export default function ConcretedOperationsSourceEmptyState() {
  return (
    <DashboardEmptyStateCard
      icon={RocketIcon}
      title={Trans(
        translations,
        'HereYouWillSeeTheSourceOfContactsWhoConcretedAnOperation'
      )}
      description={Trans(
        translations,
        'MakeSureAllYourContactsHaveTheirSourceTag'
      )}
    />
  );
}
